<template>
  <validation-provider mode="eager" :name="refGroupMeta.description">
    <v-autocomplete
      v-if="refGroupMeta.max_items === 1"
      :id="id"
      v-model="formData[0]"
      :items="items"
      dense
      outlined
      return-object
      clearable
      :label="refGroupMeta.description"
      :readonly="readonly"
      item-text="title"
      item-value="node_id_2"
      class="sv-autocomplete"
    />
    <v-autocomplete
      v-else
      :id="id"
      v-model="formData"
      :items="items"
      multiple
      dense
      outlined
      chips
      deletable-chips
      small-chips
      return-object
      :label="refGroupMeta.description"
      :readonly="readonly"
      item-text="title"
      item-value="node_id_2"
      class="sv-autocomplete"
    />
  </validation-provider>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    },
    refItems: {
      type: Array,
      required: true
    },
    refGroupMeta: {
      type: Object,
      required: true
    },
    nodeLang: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    items() {
      return this.refItems.map(item => {
        const { node_id_2, realm_class_link_id, group } = item;
        const title = item.titles[this.nodeLang];
        return { node_id_2, realm_class_link_id, title, group };
      });
    }
  },

  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    return {
      formData
    };
  }
};
</script>
